import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { TranslateModule } from '@ngx-translate/core'

import { BenefitsFormGroup } from '../../services/estimate-balance-form.service'

@Component({
  selector: 'mmx-balance-benefits-options-menu',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSlideToggleModule,
    TranslateModule,
  ],
  templateUrl: './balance-benefits-options-menu.component.html',
  styleUrls: ['./balance-benefits-options-menu.component.scss'],
})
export class BalanceBenefitsOptionsMenuComponent {
  @Input({ required: true }) form!: BenefitsFormGroup
  @Input() hasSecondaryInsurance = false

  @Output() readonly committed = new EventEmitter<void>()

  get hasSecondary(): boolean {
    return this.form.controls.hasSecondary.value === true
  }

  onHasSecondaryToggle(checked: boolean): void {
    this.form.controls.hasSecondary.setValue(checked)
    this.committed.emit()
  }

  onCoversChange(): void {
    this.committed.emit()
  }
}
